<div class="contenedor-blogs">
  <h1 class="titulo-bloque">BLOGS | ÚLTIMAS PUBLICACIONES</h1>
  <ng-container *ngFor="let item of posts; trackBy: trackPost">
    <div class="item-blog">
      <a [routerLink]="['blogs', item?.nombreSubseccion | kebabCase, 'posts', item?.idVideo, item?.tituloSeo | kebabCase]">
        <div class="blog">
          <div class="imagenPost">
            <img class="imagen-autor" [src]="item?.imgAutor" alt="imagen autor" loading="lazy" width="100%" height="100%" />
          </div>
          <div class="secc-data-user">
            <p class="tituloBlog">BLOG: {{ item?.nombreSubseccion }}</p>
            <p class="tituloPost">{{ item?.tituloVideo }}</p>
            <p class="tituloAutor">
              por {{ item?.nombreAutor }} <span class="fechaBlog">{{ item?.fecha | date: "dd-MM-yyyy" }}</span>
            </p>
          </div>
        </div>
      </a>
    </div>
  </ng-container>
</div>
